import { z } from '@lucidlink/dto/z';
// TODO: replace WebService '#utils/conversions' refs with '@lucidlink/dto/conversion.utils'. Kill obsolete
export const castToIntegerWithSchema = (schema) => z.preprocess((val) => Number.parseInt(String(val), 10), schema);
export const castToInteger = castToIntegerWithSchema(z.int());
export const castToBoolean = z
    .enum(['true', 'false'])
    .transform((val) => val === 'true');
export const castToPositiveIntegerOrInfinity = z.union([
    castToIntegerWithSchema(z.int().nonnegative()),
    z
        .string()
        .regex(/^infinity$/i)
        .transform(() => Infinity),
]);
/**
 * Calculates day difference between start date (in milliseconds) and end date (in milliseconds)
 * @param startDate {number} in milliseconds
 * @param endDate {number} in milliseconds
 */
export const getDayDifferenceFromMilliseconds = (startDate, endDate) => {
    if (startDate > endDate) {
        return 0;
    }
    const millisecondsPerDay = 24 * 60 * 60 * 1000;
    return (endDate - startDate) / millisecondsPerDay;
};
export const removeNullAndUndefinedValues = (obj) => {
    const cleaned = {};
    for (const [key, value] of Object.entries(obj)) {
        if (value !== null && value !== undefined) {
            cleaned[key] = value;
        }
    }
    return cleaned;
};
export const trueValue = z
    .literal(true)
    .or(z.literal('true').transform(() => true));
